import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges, ElementRef } from '@angular/core';

import { BehaviorSubject, Observable, of, merge } from 'rxjs';


import { Site, Supervision, IssueType, SupervisionError, SupervisionErrorStatusEnum, SupervisionStatusEnum, InfoIssue } from 'solar-bo';
import { IssueImageComponent } from '../issueimage/issueimage.component';
import { MapSupervisionHelper } from '@solar/ol';
import { SortHelper } from 'shtools';

import { SolarBase1Component } from '@solar/solar/solar-base/solar-base1.component';
import { SupervisionFilter } from '../superv-main/supervis-filter.model';
import { IssueTypeHelper } from '@solar/solar/models';


@Component({
  selector: 'app-ex-issue-list-base',
  template: '',
})
export abstract class IssueListBaseComponent extends SolarBase1Component implements OnInit, AfterViewInit {

  issueTypeEnum = IssueType;//for use in html

  @Input() site: Site;
  @Input() supervision: Supervision;

  private _issuesOriginal: SupervisionError[] = [];
  @Input()
  public get issuesOriginal(): SupervisionError[] {
    return this._issuesOriginal;
  }
  public set issuesOriginal(value: SupervisionError[]) {
    this._issuesOriginal = value;
    if (value) {
      this.issueTotalCount = value.length;
    }
    else {
      this.issueTotalCount = 0;
    }
  }

  private _issues: SupervisionError[] = [];
  @Input()
  public get issues(): SupervisionError[] {
    return this._issues;
  }
  public set issues(value: SupervisionError[]) {
    this._issues = value;
  }
  @Input() svFilter: SupervisionFilter = {} as SupervisionFilter;


  issueSelected: SupervisionError = null;
  @Output() issueSelectedEvent: EventEmitter<any> = new EventEmitter();
  @Output() filterChangedEvent: EventEmitter<any> = new EventEmitter();
  @Output() componentEvent: EventEmitter<{ eventName: string, value: any }> = new EventEmitter();

  /**
   * list with issues to show in components
   */
  filteredList: any[] = [];
  dataChange: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  issueTotalCount: number = 0;
  issuecount: number = 0;
  issuecheckedcount: number = 0;
  issuenoerrorcount: number = 0;
  issueRepeatedCount: number = 0;
  issueErrorCountToValidate: number = 0;
  uiStatusOpen: boolean = true;


  constructor() {
    super();
    this.svFilter.filterSelected = [];
    this.svFilter.filter_status = SupervisionErrorStatusEnum.none;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

  }

  customSort(event: any) {
    console.log("customSort", event);
    let col = event.field;
    let direction = event.order;
    let sort;
    switch (col) {
      case "name":
        //todo:preparar para ordenar por el numero de columnas del site
        sort = ['asc', 'asc', 'asc', 'asc'];
        if (event.order != 1) {
          sort = ['desc', 'desc', 'desc', 'desc'];
        }
        this.filteredList = SortHelper.sortMultiple(this.filteredList, ['info.panel.locator.L1', 'info.panel.locator.L2', 'info.panel.locator.L3', 'info.panel.locator.L4'], sort);
        break;
      case "type":
        sort = ['asc'];
        if (event.order != 1) {
          sort = ['desc'];
        }
        this.filteredList = SortHelper.sortMultiple(this.filteredList, ['type'], sort);
        break;
    }
  }

  selectRow(index: number) {
    throw new Error("This method must be overwriten");//o abstract
  }

  selectRowById(id: string): number {
    console.log("selectRowById this.issues.length: " + this.issues.length + " issuesFiltered: " + this.filteredList.length);
    let index = this.filteredList.findIndex(elem => elem.id == id);
    if (index > -1) {
      this.selectRow(index);
    }
    return index;
  }

  issueGetIndexById(id: string) {
    let index = this.filteredList.findIndex(elem => elem.id == id);
    return index;
  }


  configIssueList(newlist: any[]) {
    console.log('configIssueList', newlist);
    this.listerrmessage = '';

    this.issues = newlist;
    this.issuecount = this.issues.length;

    this.configsource(this.issues);

    this.alertmessage = null;
    this.loading = false;
  }

  getListhandleError<T>(err: any) {
    this.loading = false;
    this.handleError(err, "Error retrieving supervision issues");
  }

  abstract configsource(list: any[])

  showErrorAll() {
    this.svFilter.filter_status = SupervisionErrorStatusEnum.none;
    this.svFilter.filter_status_type = null;
    this.filterListByErrorType();
  }


  abstract filterListByErrorType()

  uiConfigStats() {
    try {
      this.issuecount = this.issues.length;
      this.issuecheckedcount = this.issues.filter(elem => elem.info.status == SupervisionErrorStatusEnum.validated).length;
      this.issuenoerrorcount = this.issues.filter(elem => elem.info.statusType == SupervisionErrorStatusEnum.noerror).length;
      this.issueErrorCountToValidate = this.issuecount - this.issuecheckedcount;
    }
    catch (err) {
      console.log(err, "Error retrieving supervision issues");
    }
  }

  getIssueCount() {
    if (this.issuecount == this.issueTotalCount) {
      //No filter applied
      return this.issueTotalCount;
    } else {
      return "Showing " + this.issuecount + " of " + this.issueTotalCount;
    }
  }

  uiurlimg(issue: SupervisionError): string {
    return MapSupervisionHelper.issueUrlImg(issue, this.supervision.site.id, this.supervision.id);
  }

  openimage(row) {
    IssueImageComponent.openModal(this.dialog, row, this.supervision);
  }

  issueShowOnMap(item) {
    this.issueSelected = item;
    this.issueSelectedEvent.emit(item);
  }


  panelPatternList: string;
  /**
   * to show the locator in lists
   * @param issue 
   */
  uiLocator(issue: SupervisionError) {
    if (!this.panelPatternList) {
      this.panelPatternList = Site.getPanelPattern(this.supervision.site, "list");
    }
    return SupervisionError.uiLocator(issue, this.panelPatternList);
  }
  /**
   * to show the locator in lists
   * @param issue 
   */
  panelCoords(issue: SupervisionError): string {
    let panel = issue.info.panel;
    let geom = panel.geom;
    if (geom && geom.coordinates) {
      let coords: any[] = geom.coordinates;
      if (coords.length > 0) {
        return coords[0][0][0] + "," + coords[0][0][1];
      }
    } else {
      return "--";
    }

  }


  ui_btn_errortype_class(issue, errorType: IssueType) {
    if (!issue) {
      return "";
    }
    if (issue.type === errorType) {
      return "btn-primary text-white";
    }
  }

  ui_relevance(issue) {
    if (!issue) {
      return "";
    }

    if (issue.info) {
      return issue.info.relevance;
    }
  }
  /**
   * Show the description of an issue 
   * @param issue 
   */
  ui_errortype(issue) {
    return IssueTypeHelper.issueGetErrorTypeDescription(issue.type);
  }

}




